module.exports = __webpack_public_path__ + "static/sequelize-banner-aa084fb79fadfa1c0fc483b5092f44f5.png";